export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_fragment_5.e6ecd8ea.jpg";